export function modbusDeviceViewTokenGuestSearch(search: string): boolean {
  const q = new URLSearchParams(search);
  return Boolean(String(q.get("id") || "").trim() && String(q.get("view_token") || "").trim());
}
/** Standalone fullscreen for any concrete device (?id=). Logged-in ``?mdv_window=1`` still turns on the 1h server window cookie. */
